export class Price {
    value;
  
    constructor(value) {
      this.value = value || 23; // 23 for guffy projects in login ...
    }
  }